import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const collectionIncentiveObject = z.object({
  id: z.string().uuid(),
  benefitProgramId: z.string().uuid(),
  citizenId: z.string().uuid(),
  totalQuantity: z.number().int(),
  totalIncentiveAmount: z.number(),
  totalDiscountAmount: z.number(),
  totalDebitAmount: z.number(),
  notes: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CollectionIncentiveType = z.infer<typeof collectionIncentiveObject>

export const propertyMap = {
  id: sql`id`,
  benefitProgramId: sql`benefit_program_id`,
  citizenId: sql`citizen_id`,
  totalQuantity: sql`total_quantity`,
  totalIncentiveAmount: sql`total_incentive_amount`,
  totalDiscountAmount: sql`total_discount_amount`,
  totalDebitAmount: sql`total_debit_amount`,
  notes: sql`notes`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
